import { Component } from '@angular/core';

/** Entry point propio de Historial Áridos; delegación temporal al legacy. */
@Component({
  selector: 'app-aridos-mixer-history-entry',
  template: '<app-aridos-history></app-aridos-history>',
  standalone: false,
})
export class AridosMixerHistoryEntryComponent {}
